import React, { useState } from "react";

import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

const ALLOWED_KEYS = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab", "Enter", "Home", "End"];

const NumberOnlyInput = (props) => {
  const handleKeyDown = (e) => {
    if (!/^[0-9-]$/.test(e.key) && !ALLOWED_KEYS.includes(e.key)) {
      e.preventDefault();
    }
  };
  return <components.Input {...props} onKeyDown={handleKeyDown} />;
};

function DropDownPicker({ options, onChange, value, isDisabled, isComprobanteGroup, isCreatable, placeholder, containerStyle, numberOnly }) {

  const [inputValue, setInputValue] = useState("");

  const defaultPlaceholder = isComprobanteGroup
    ? "Seleccione los grupos de usuario que visualizarán el comprobante"
    : isDisabled
    ? "Aún no hay usuarios que pertenezcan a este grupo"
    : "Seleccione usuarios pertenecientes al grupo";

  const Component = isCreatable ? CreatableSelect : Select;

  const isValidInput = (val) => {
    if (!val || !val.trim()) return false;
    if (numberOnly) return /^[0-9-]+$/.test(val.trim());
    return true;
  };

  const createAndAdd = (val) => {
    if (!isValidInput(val)) return;
    const trimmed = val.trim();
    const already = (value || []).some((opt) => String(opt.value) === trimmed);
    if (already) return;
    const newOption = { label: trimmed, value: trimmed };
    onChange([...(value || []), newOption]);
    setInputValue("");
  };

  const handleBlur = () => {
    if (isCreatable) createAndAdd(inputValue);
  };

  return (
    <Component
      placeholder={placeholder ?? defaultPlaceholder}
      closeMenuOnSelect={true}
      closeMenuOnScroll={false}
      menuPlacement="auto"
      menuPosition="fixed"
      menuShouldScrollIntoView={false}
      styles={{
        container: (base) => ({
          ...base,
          width: "100%",
          ...containerStyle,
        }),
        valueContainer: (base) => ({
          ...base,
          justifyContent: "center",
        }),
        multiValue: (base) => ({
          ...base,
          justifyContent: "center",
          margin: "2px 6px",
        }),
        multiValueLabel: (base) => ({
          ...base,
          backgroundColor: "rgb(116, 122, 218)",
          color: "white",
          borderRadius: "none",
          fontSize: numberOnly ? "1.2rem" : "1rem",
          fontWeight: numberOnly ? "bold" : "normal",
        }),
        multiValueRemove: (base) => ({
          ...base,
          backgroundColor: "rgb(116, 122, 218)",
          color: "white",
          borderRadius: "none",
          fontSize: numberOnly ? "1.2rem" : "1rem",
        }),
        input: (base) => ({
          ...base,
          fontSize: numberOnly ? "1.2rem" : "1rem",
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: "20vh",
          overflowY: "auto",
        }),
        option: (base, state) => ({
          ...base,
          textAlign: "center",
          backgroundColor: state.isFocused ? "#f8b03d66" : "white",
          color: "black",
        }),
      }}
      components={numberOnly ? { Input: NumberOnlyInput } : undefined}
      isMulti
      options={isCreatable ? [] : options}
      onChange={(value) => onChange(value)}
      value={value}
      isDisabled={isDisabled}
      inputValue={isCreatable ? inputValue : undefined}
      onInputChange={isCreatable ? (val) => setInputValue(val) : undefined}
      onBlur={isCreatable ? handleBlur : undefined}
      isValidNewOption={numberOnly ? (inputValue) => /^[0-9-]+$/.test(inputValue.trim()) : undefined}
      noOptionsMessage={isCreatable ? () => "Escriba un valor y presione Enter" : undefined}
    />
  );
}
export default DropDownPicker